import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Typography, CardMedia } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import defaultImage from "../../assets/img/item_image.png"; // Adjust the path as necessary

export default function ItemSidebar({
  CollectionTableItems,
  indexTableItem,
  billData,
  setbillData,
  collectionTableItemsduplicate,
  setCollectionTableItemsduplicate,
  searchItemValue,
  setSeachItemValue,
}) {
  return (
    <Box
      mt={2}
      sx={{ maxHeight: "50vh", overflowY: "auto", padding: "0px 10px" }}
    >
      {collectionTableItemsduplicate[indexTableItem]?.tableItems?.map(
        (item, index) => {
          const handleAdd = () => {
            const ind = billData?.counterSalesChild.findIndex(
              (table) => table.itemId === item.id
            );
            if (ind !== -1) {
              const arr = [...billData.counterSalesChild];
              arr[ind] = {
                ...arr[ind],
                quantity: arr[ind].quantity + 1,
                amount:
                  (arr[ind].rate + (arr[ind].rate * arr[ind].gst) / 100) *
                  (arr[ind].quantity + 1),
              };
              setbillData({
                ...billData,
                counterSalesChild: arr,
              });
            }
            const updatedCollection = [...collectionTableItemsduplicate];
            if (updatedCollection[indexTableItem]?.tableItems?.[index]) {
              updatedCollection[indexTableItem].tableItems[index] = {
                ...updatedCollection[indexTableItem].tableItems[index],
                quantity:
                  updatedCollection[indexTableItem].tableItems[index].quantity +
                  1,
              };
              setCollectionTableItemsduplicate(updatedCollection);
            }
          };

          const handleRemove = () => {
            const ind = billData?.counterSalesChild.findIndex(
              (table) => table.itemId === item.id
            );
            if (ind !== -1) {
              const arr = [...billData.counterSalesChild];
              const currentQty = arr[ind].quantity;
              if (currentQty > 1) {
                arr[ind] = {
                  ...arr[ind],
                  quantity: currentQty - 1,
                  amount:
                    (arr[ind].rate + (arr[ind].rate * arr[ind].gst) / 100) *
                    (currentQty - 1),
                };
              } else {
                arr.splice(ind, 1);
              }
              setbillData({
                ...billData,
                counterSalesChild: arr,
              });
            }
            const updatedCollection = [...collectionTableItemsduplicate];
            if (updatedCollection[indexTableItem]?.tableItems?.[index]) {
              const currentQty =
                updatedCollection[indexTableItem].tableItems[index].quantity;
              updatedCollection[indexTableItem].tableItems[index] = {
                ...updatedCollection[indexTableItem].tableItems[index],
                quantity: Math.max(0, currentQty - 1),
              };
              setCollectionTableItemsduplicate(updatedCollection);
            }
          };

          const handleCardClick = () => {
            const ind = billData?.counterSalesChild.findIndex(
              (table) => table.itemId === item.id
            );
            if (ind === -1) {
              const arr = [...billData.counterSalesChild];
              const obj = {
                itemId: item.id,
                gst: item.gst,
                amountWithPayPercentage: item.amountWithPayPercentage,
                cgst: item.cgst,
                igstAmount: (item.price * item.igst) / 100,
                cgstAmount: (item.price * item.cgst) / 100,
                igst: item.igst,
                rawMaterialValueWithPayPercentage:
                  item.rawMaterialValueWithPayPercentage,
                rawMaterialValue: item.rawMaterialValue,
                employeeName: item.employeeName,
                employeePayPercentage: item.employeePayPercentage,
                amount: (item.price + (item.price * item.gst) / 100) * 1,
                sgst: item.sgst,
                sgstAmount: (item.price * item.sgst) / 100,
                unit: item.unit,
                gstAmount: item.gst,
                itemDescription: item.itemDescription,
                quantity: 1,
                rate: item.price,
              };
              console.log(obj);
              arr.push(obj);
              setbillData({
                ...billData,
                counterSalesChild: arr,
              });
              const updatedCollection = [...collectionTableItemsduplicate];
              if (updatedCollection[indexTableItem]?.tableItems?.[index]) {
                updatedCollection[indexTableItem].tableItems[index] = {
                  ...updatedCollection[indexTableItem].tableItems[index],
                  quantity:
                    updatedCollection[indexTableItem].tableItems[index]
                      .quantity + 1,
                };
                setCollectionTableItemsduplicate(updatedCollection);
              }
            }
          };
          if (
            item?.itemDescription
              ?.toLowerCase()
              ?.includes(searchItemValue?.toLowerCase())
          ) {
            return (
              <Card
                elevation={0}
                key={"tableitems" + index}
                sx={{
                  display: "flex",
                  mb: 1,
                  cursor: "pointer",
                  p: 1,
                  backgroundColor: "#EEEEFF",
                }}
                onClick={handleCardClick}
              >
                <CardMedia
                  component="img"
                  image={
                    item?.imagePath1 ||
                    item?.imagePath2 ||
                    item?.imagePath3 ||
                    item?.imagePath4 ||
                    defaultImage
                  }
                  alt="image"
                  sx={{ width: 70, height: 70, borderRadius: 1 }}
                />
                <Box ml={2} sx={{ flexGrow: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={5}>
                      <Typography
                        fontWeight={500}
                        fontSize="13px"
                        color="#434343"
                      >
                        #{item?.id}
                      </Typography>
                      <Typography
                        fontWeight={700}
                        fontSize="18px"
                        color="#01008B"
                      >
                        {item?.itemDescription}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography
                        fontWeight={500}
                        fontSize="13px"
                        color="#434343"
                      >
                        {item?.unit}
                      </Typography>
                      <Typography
                        fontWeight={600}
                        fontSize="12px"
                        color="#01008B"
                      >
                        ₹ {item?.price}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {item?.quantity > 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "white",
                          }}
                        >
                          <RemoveIcon
                            style={{
                              fontSize: "12px",
                              color: "#333",
                              border: "1px solid #333",
                              borderTopLeftRadius: "4px",
                              borderBottomLeftRadius: "4px",
                              padding: "5px 8px",
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemove();
                            }}
                          />
                          <Typography
                            fontWeight={700}
                            fontSize="13px"
                            sx={{
                              backgroundColor: "white",
                              color: "#01008B",
                              padding: "4px 8px",
                            }}
                          >
                            {item?.quantity}
                          </Typography>
                          <AddIcon
                            style={{
                              color: "#333",
                              border: "1px solid #333",
                              fontSize: "12px",
                              borderTopRightRadius: "4px",
                              borderBottomRightRadius: "4px",
                              padding: "5px 8px",
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAdd();
                            }}
                          />
                        </Box>
                      ) : (
                        <Box
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardClick();
                          }}
                          sx={{
                            backgroundColor: "#01008B",
                            color: "white",
                            padding: "8px 12px",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          Add Bill
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            );
          }
        }
      )}
    </Box>
  );
}
